import { GraphData, FlowEdge } from '../types';
import { data as pocData } from '../../assets/pocDataNested';
import { transformApiToGraphData } from "./transformApiToAppData";
import apiResponse from '../../assets/SampleVS.json';
import flowsData from '../../assets/flows.json';
import transitionsData from '../../assets/transitions.json';

export class DataLoader {
  public async loadPocData(): Promise<GraphData> {
    // In a real application, this would fetch data from an API or other source
    // For now, it returns the existing POC data
    return Promise.resolve(pocData);
  }

  public async loadSampleApiData(): Promise<GraphData> {
    //return Promise.resolve(pocData);
    // Transform data from SampleVS.json
    const transformedData = transformApiToGraphData(apiResponse as any, transitionsData);
    console.debug('Transformed data:', transformedData);
    // Process data from Outcomes.json
    //const outcomeFlows = processOutcomesJson(JSON.stringify(outcomesData)).flows;
    // Convert Flow objects to FlowEdge objects
    // const outcomeFlowEdges = outcomeFlows.map(flow => ({
    //   SourceLeaf: flow.SourceLeaf,
    //   TargetLeaf: flow.TargetLeaf
    // })) as FlowEdge[];
    
    // Combine the data by adding the outcome flows to the transformed data
    const combinedData: GraphData = {
      ...transformedData,
      flows: [...transformedData.flows, /*...outcomeFlowEdges*/]
    };
    
    return Promise.resolve(combinedData);
  }

  /**
   * Loads flows from the local flows.json file
   * @returns Array of FlowEdge objects
   */
  private getFlowsFromFile(): FlowEdge[] {
    console.debug('Loading flows from local file');
    return flowsData.flows.map(flow => ({
      SourceLeaf: flow.SourceLeaf,
      TargetLeaf: flow.TargetLeaf
    })) as FlowEdge[];
  }

  public async loadDataFromApi(capsifiService: any, valueStreamId: string, useLocalFlows: boolean = false): Promise<GraphData> {
    // Load value stream details
    const apiResponse = await capsifiService.getValueStreamDetails(valueStreamId);
    
    // Fetch transitions data for creating flow edges
    let transitionsData = null;
    try {
      transitionsData = await capsifiService.getValueStreamTransitions({
        itemId: valueStreamId
      });
      console.debug('Transitions data loaded:', transitionsData);
    } catch (error) {
      console.error('Error loading transitions data:', error);
    }
    
    // Transform API data to graph data, passing transitions data if available
    const transformedData = transformApiToGraphData(apiResponse as any, transitionsData);
    
    try {
      let outcomeFlowEdges: FlowEdge[] = [];
      
      if (useLocalFlows) {
        // Load flows from local file
        outcomeFlowEdges = this.getFlowsFromFile();
      } 
      // Note: We're now getting flows from transitions in transformApiToGraphData
      // so we may not need to add these additional flows if they're duplicates
      return {
        ...transformedData,
        flows: useLocalFlows ? [...transformedData.flows, ...outcomeFlowEdges] : transformedData.flows
        //flows: [...transformedData.flows, ...outcomeFlowEdges]
      };
    } catch (error) {
      console.error('Error loading outcomes:', error);
      // Return just the transformed data if there's an error loading outcomes
      return transformedData;
    }
  }
}